export default __webpack_public_path__ + "hand-pointing-to-left-direction.png";